export const ESIM_IMAGE_ID = 'qooj3ldzuulsgukb3ww4'

export const ESIM_IMAGE: App.Image = {
  id: ESIM_IMAGE_ID,
  title: 'Free travel eSIM for Société members',
}
